export const INTERIOR_AREA_TYPES = {
  SMALL_ROOM: "small_room",
  MEDIUM_ROOM: "medium_room",
  LARGE_ROOM: "large_room",
  CUSTOM_ROOM: "custom_room",
  BATHROOM: "bathroom",
  CUSTOM_WALL: "custom_wall",
};

export const EXTERIOR_AREA_TYPES = {
  HOUSE: "house",
};

export const INTERIOR_AREA_ROOM_TYPES = [
  INTERIOR_AREA_TYPES.SMALL_ROOM,
  INTERIOR_AREA_TYPES.MEDIUM_ROOM,
  INTERIOR_AREA_TYPES.LARGE_ROOM,
  INTERIOR_AREA_TYPES.CUSTOM_ROOM,
  INTERIOR_AREA_TYPES.BATHROOM,
];

export const INTERIOR_AREA_OPTION_LABELS = {
  [INTERIOR_AREA_TYPES.SMALL_ROOM]: "Small Room",
  [INTERIOR_AREA_TYPES.MEDIUM_ROOM]: "Medium Room",
  [INTERIOR_AREA_TYPES.LARGE_ROOM]: "Large Room",
  [INTERIOR_AREA_TYPES.CUSTOM_ROOM]: "Custom Room",
  [INTERIOR_AREA_TYPES.BATHROOM]: "Bathroom",
  [INTERIOR_AREA_TYPES.CUSTOM_WALL]: "Custom Wall",
};

export const EXTERIOR_AREA_OPTION_LABELS = {
  [EXTERIOR_AREA_TYPES.HOUSE]: "House",
};

// Dimension units are cm
export const INTERIOR_AREA_DEFAULTS = {
  [INTERIOR_AREA_TYPES.SMALL_ROOM]: {
    width: "3",
    length: "3",
    height: "2.4",
    doors: "1",
    windows: "1",
    type: INTERIOR_AREA_TYPES.SMALL_ROOM,
  },
  [INTERIOR_AREA_TYPES.MEDIUM_ROOM]: {
    width: "3",
    length: "4",
    height: "2.4",
    doors: "2",
    windows: "1",
    type: INTERIOR_AREA_TYPES.MEDIUM_ROOM,
  },
  [INTERIOR_AREA_TYPES.LARGE_ROOM]: {
    width: "4",
    length: "5",
    height: "2.4",
    doors: "2",
    windows: "2",
    type: INTERIOR_AREA_TYPES.LARGE_ROOM,
  },
  [INTERIOR_AREA_TYPES.CUSTOM_ROOM]: {
    width: "",
    length: "",
    height: "",
    doors: "0",
    windows: "0",
    type: INTERIOR_AREA_TYPES.CUSTOM_ROOM,
  },
  [INTERIOR_AREA_TYPES.BATHROOM]: {
    width: "",
    length: "",
    height: "",
    doors: "0",
    windows: "0",
    type: INTERIOR_AREA_TYPES.BATHROOM,
  },
  [INTERIOR_AREA_TYPES.CUSTOM_WALL]: {
    length: "",
    height: "2.4",
    doors: "0",
    windows: "0",
    type: INTERIOR_AREA_TYPES.CUSTOM_WALL,
  },
};

export const EXTERIOR_AREA_DEFAULTS = {
  [EXTERIOR_AREA_TYPES.HOUSE]: {
    width: "",
    length: "",
    height: "",
    doors: "0",
    windows: "0",
    type: EXTERIOR_AREA_TYPES.HOUSE,
  },
};
